import React from 'react';
import PageMeta from '../../components/common/PageMeta';
import FooterOne from '../../layout/Footer/FooterOne';
import Navbar from '../../layout/Header/Navbar';
import Layout from '../../layout/Layout';
// import DisclaimerHeroSection from './DisclaimerHeroSection.js';

const Disclaimer = () => {
    return (
        <Layout >
            <div
                style={{ background: "radial-gradient(75% 25% at 50% 0%, rgb(216 223 235), rgb(255, 255, 255))" }}
            >
                <PageMeta />
                <Navbar />
                <section
                    className='page-header position-relative overflow-hidden pt-60 pb-60 '

                >
                    <div className='container'>
                        <div className='row justify-content-center'>
                            <div className='col-lg-12 col-md-12'>
                                <div className='text-center'>
                                    <h1 className=' fw-bold'>Disclaimer</h1>
                                    <p className='lead'>
                                        The information provided by Senertech Software Private Limited ('we', 'us', or 'our') on https://www.senertech.in (the 'Site') is for general informational purposes only. All information on the site is provided in good faith; however, we make no representation or warranty of any kind, express or implied, regarding the accuracy, adequacy, validity, reliability, availability, or completeness of any information on the site.
                                    </p>

                                    <p className='lead'>
                                        Under no circumstances shall we have any liability to you for any loss or damage of any kind incurred as a result of the use of the site or reliance on any information provided on the site. Your use of the site and your reliance on any information on the site are solely at your own risk.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className='pt-60 '>
                            <h4 className=' fw-semibold'>External Links</h4>
                            <p>The site may contain (or you may be sent through the site) links to other websites or content belonging to or originating from third parties, or links to websites and features in banners or other advertising. Such external links are not investigated, monitored, or checked for accuracy, adequacy, validity, reliability, availability, or completeness by us.</p>
                            <p>We do not warrant, endorse, guarantee, or assume responsibility for the accuracy or reliability of any information offered by third-party websites linked through the site or any website or feature linked in any banner or other advertising. We will not be a party to or in any way be responsible for monitoring any transaction between you and third-party providers of products or services.</p>
                        </div>

                          <div className='pt-60 '>
                            <h4 className=' fw-semibold'>Testimonials</h4>
                            <p>The site may contain testimonials by users of our products and/or services. These testimonials reflect the real-life experiences and opinions of such users. However, the experiences are personal to those particular users and may not necessarily be representative of all users of our products and/or services. We do not claim, and you should not assume, that all users will have the same experiences. Your individual results may vary.</p>
                            <p>The testimonials on the site are submitted in various forms such as text, audio and/or video, and are reviewed by us before being posted. They appear on the site verbatim as given by the users, except for the correction of grammar or typing errors. Some testimonials may have been shortened for the sake of brevity, where the full testimonial contained extraneous information not relevant to the public.</p>
                             <p>The views and opinions contained in the testimonials belong solely to the individual user and do not reflect our views and opinions. We are not affiliated with users who provide testimonials, and users are not paid or otherwise compensated for their testimonials.</p>
                        </div>

                    </div>
                </section>

                {/* <DisclaimerHeroSection /> */}
                <FooterOne
                    style={{
                        background:
                            "url('assets/img/page-header-bg.svg')no-repeat bottom left",
                    }}
                />
            </div>
        </Layout>
    );
};

export default Disclaimer;
